import { MicrophoneSettingsIcon } from './MicrophoneSettingsIcon';

/**
 * author: Google
 * id E8F70177-01CF-4C20-9956-DCA7B331FED6
 * name microphone-settings
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/microphone-settings.svg
 * tags
 * - Settings 
 */
export const SettingsVoiceIcon = MicrophoneSettingsIcon;
export default SettingsVoiceIcon